import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rocket18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_681)'>
      <path
        d='M13 5.99999C13.5523 5.99999 14 5.55228 14 4.99999C14 4.44771 13.5523 3.99999 13 3.99999C12.4477 3.99999 12 4.44771 12 4.99999C12 5.55228 12.4477 5.99999 13 5.99999Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.2606 1.29672C14.293 0.567674 12.0248 1.0213 10.489 2.45104C10.4824 2.45713 10.476 2.46334 10.4697 2.46967L7.71119 5.22814L3.45751 4.93288C3.04955 4.88871 2.63679 4.93639 2.24952 5.07252C1.50923 5.33274 1.00842 5.93091 0.46967 6.46967C0.176777 6.76256 0.176777 7.23743 0.46967 7.53033L3.81409 10.8748C2.33587 11.2814 1.25 12.6352 1.25 14.2426V16.75H3.75736C5.36478 16.75 6.71858 15.6641 7.12522 14.1859L10.4697 17.5303C10.7626 17.8232 11.2374 17.8232 11.5303 17.5303L12.2676 16.7931L12.269 16.7917C12.8559 16.2099 13.156 15.3638 13.0671 14.5425L12.7719 10.2888L15.5303 7.53033C15.5367 7.524 15.5429 7.51757 15.549 7.51102C16.9787 5.97516 17.4323 3.70704 16.7033 1.73942C16.6273 1.53437 16.4656 1.37269 16.2606 1.29672ZM5.75 13.2574C5.75 14.3579 4.85786 15.25 3.75736 15.25H2.75V14.2426C2.75 13.1421 3.64214 12.25 4.74264 12.25C5.31535 12.25 5.75 12.6916 5.75 13.2574ZM7.99999 12.9394L14.4598 6.47955C15.417 5.44485 15.7794 3.95319 15.4047 2.5953C14.0468 2.2206 12.5551 2.58302 11.5204 3.54021L5.06065 10C6.04043 10.9798 7.02021 11.9596 7.99999 12.9394ZM6.30518 6.63416L4 8.93934L2.06066 7C2.41093 6.6497 2.78353 6.36519 3.30431 6.42509C4.29697 6.53925 5.30825 6.56496 6.30518 6.63416ZM9.06066 14L11.3658 11.6948C11.435 12.6917 11.4607 13.703 11.5749 14.6957C11.6354 15.222 11.346 15.5934 11 15.9393L9.06066 14Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_681'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Rocket18.displayName = 'Rocket18';
export default Rocket18;
